import logger from '@adc/logger'
import { UPDATE_PROPERTIES_SAVED_STATE_FOR_NEWLY_AUTHENTICATED_USER } from '../constants/actionTypes'
import { fetchDataForNewlyAuthenticatedUser } from '../providers/user'
import { init, fetchUserSavedSearches } from './fetchUserSavedSearches'

export { init, fetchUserSavedSearches }

export const fetchUserDetails =
  (user, propertyIds = []) =>
  async (dispatch, getState) => {
    try {
      const currentlyLoadedPropertyIds = (propertyIds || []).filter(Boolean)

      const res = await fetchDataForNewlyAuthenticatedUser({
        propertyIds: currentlyLoadedPropertyIds,
        shouldFetchAdaptiveNav: Boolean(
          getState().featureFlags?.['fe.resi.enable-new-navigation']
        ),
      })

      // NOTE: We don't handle error conditions here currently because we assumed previously resi-pal would
      // always return something to use here. Just logging for now while I bring it up with product.
      if (res.errors && !res.data.current_user) {
        logger.error(res.errors)
      }

      /* eslint-disable-next-line */
      const { saved_property_lookup, ...standardUserShape } =
        res.data.current_user

      dispatch(init({ ...standardUserShape, logged_in: true }))

      dispatch({
        type: UPDATE_PROPERTIES_SAVED_STATE_FOR_NEWLY_AUTHENTICATED_USER,

        // A little optimization here to reduce iteration count is to note that unauthenticated users never have saved
        // properties so we can just find the ones that are saved and only update those
        currently_saved_property_ids: Object.entries(saved_property_lookup)
          .filter(([, isSaved]) => isSaved)
          .map(([key]) => String(key)),
      })
    } catch (err) {
      logger.error(err)
      dispatch(init({ ...user, logged_in: true }))
    }
  }
